export const isStoreAddressField = (field: { associatedVariable?: string; title?: string }) =>
    field.associatedVariable === '{Address}'
    || (!field.associatedVariable && ['Store Address', 'Address'].includes(field.title));

export const needsOrderingCloneAddressGeneration = (assistantType: string, clone: boolean) =>
    assistantType === 'ai-ordering' && clone;

export const getLocationAutofillVariable = (field: { associatedVariable?: string; title?: string }, assistantType: string) =>
    field.associatedVariable || (assistantType === 'ai-ordering' && isStoreAddressField(field) ? '{Address}' : undefined);
